// src/App.js
import React, { useEffect, useState } from 'react';
import HeroSection from './components/HeroSection';
import AboutUs from './components/AboutUs';
import Technology from './components/Technology';
import Team from './components/Team';
import Navbar from './components/Navbar';
import Contact from './components/Contact.js';
import Footer from './components/Footer.js';
import DemoSection from './components/DemoSections.js';
import DocumentViewer from './components/DocumentViewer';
import CookieConsent from './components/CookieConsent';
import CookiePolicy from './pages/CookiePolicy';
import TermsConditions from './pages/TermsConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';

const App = () => {
  const [showDocumentViewer, setShowDocumentViewer] = useState(false);
  const [showCookiePolicy, setShowCookiePolicy] = useState(false);
  const [showTermsConditions, setShowTermsConditions] = useState(false);
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);
  const [documentId, setDocumentId] = useState(null);
  const [token, setToken] = useState(null);

  useEffect(() => {
    // Check if the URL path matches "/documents/gep", "/cookies", "/terms", or "/privacy"
    const path = window.location.pathname;
    
    if (path === '/documents/gep') {
      setDocumentId('gep');
      // No token needed in the URL anymore
      setToken('internal-access');
      setShowDocumentViewer(true);
    } else if (path === '/cookies') {
      setShowCookiePolicy(true);
    } else if (path === '/terms') {
      setShowTermsConditions(true);
    } else if (path === '/privacy') {
      setShowPrivacyPolicy(true);
    }
  }, []);

  // Render PrivacyPolicy when accessing privacy URL
  if (showPrivacyPolicy) {
    return <PrivacyPolicy />;
  }

  // Render TermsConditions when accessing terms URL
  if (showTermsConditions) {
    return <TermsConditions />;
  }

  // Render CookiePolicy when accessing cookie policy URL
  if (showCookiePolicy) {
    return <CookiePolicy />;
  }

  // Render DocumentViewer when accessing a document URL
  if (showDocumentViewer) {
    return <DocumentViewer documentId={documentId} token={token} />;
  }

  // Otherwise render the normal website
  return (
    <div>
      <Navbar />
      <HeroSection />
      <AboutUs />
      <Technology />
      <DemoSection />
      <Team />
      <Contact />
      <Footer />
      <CookieConsent />
    </div>
  );
};

export default App;